export default __webpack_public_path__ + "static/media/lottery-icon.60255943.svg";